<sm-options-content-layout optionsWidthClass="width300" mobileMode="overlay" contentStyleClass="flex-col width100p">
    <ng-template #options>
        <p-panel class="height100p full-height" [header]="app.t('ProjectPlanning.options')">
            <div class="height100p flex-col-fixed-fill">
                <sm-form class="mt-3" [form]="form"></sm-form>
                @if (selectedProject != null) {
                    <app-project-information class="mt-5" [project]="selectedProject.project" [stats]="selectedProject.stats" [detailed]=true></app-project-information>
                }
            </div>
        </p-panel>
    </ng-template>

    <ng-template #content>
        <sm-table class="flex-item-fill height100p" [floatingFilter]=true [data]="table" headerAlign="center" columnWidthMode="contentNoExpand" [contentColumnMaxWidthRatio]="0.3" (onRowSelect)="selectRow($event)" (onCellClicked)="clickCell($event)"></sm-table>
    </ng-template>
</sm-options-content-layout>